<template>
  <div class="file-box-failed">
    <div class="file-box-failed__icon">
      <svg-loader src="/static/images/icon-failed-red.svg" />
    </div>
    <div class="file-box-failed__error-message">
      <p>{{ errorMessage }}</p>
    </div>
    <div class="file-box-failed__cta">
      <button
        class="btn btn-nonenary btn-small"
        @click="tryAgain()"
      >
        Tentar novamente
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileBoxFailed',
  props: {
    errorMessage: {
      type: String,
      default: 'Não foi possível fazer o upload'
    }
  },
  methods: {
    tryAgain () {
      this.$emit('try-again')
    }
  }
}
</script>

<style lang="scss">
.file-box-failed {
  display: flex;
  background-color: #f0dedd;
  border-radius: 4px;
  height: 52px;
  align-items: center;
  padding: 0 0.1em 0 0.8em;

  &__icon,
  &__cta {
    align-content: center;
    display: flex;
  }

  &__icon {
    flex: 1;

    svg {
      height: 16px;
      width: 16px;
    }
  }

  &__error-message {
    flex: 6;

    p {
      margin: 0;
      font-weight: 400;
      font-size: 12px;
      letter-spacing: 0;
      color: #b40607;
      line-height: 12px;
    }
  }

  &__cta {
    flex: 4;

    button {
      font-size: 10px;
      letter-spacing: 1.33px;
    }
  }
}
</style>

